import React, { useState } from "react";
// import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Instructors from "../../files/Instructors_en.json";

const Contacts_In = () => {
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    // telephone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    // handleShow();

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/info@londonkickboxing.co.uk",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        },
      );

      const result = await response.json();

      if (result.success) {
        setStatus("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          // telephone: "",
          message: "",
        });
      }
    } catch (error) {
      setStatus("Failed to send message.");
    }
  };

  return (
    <>
      <div>
        {Instructors.map(function (item, i) {
          if (item.ident === "01") {
            return (
              <div key={i} className="row">
                <div className="col-lg-12">
                  <p>
                    Please use the form below to contact London Kickboxing,
                    alternatively email us at&nbsp;
                    <Link
                      to={"mailto:" + item.email}
                      title="email london kickboxing"
                      className="normal_links"
                    >
                      {item.email}
                    </Link>
                    <br />
                    or call {item.tel}.
                  </p>
                  <br />
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
        <div className="row">
          <div className="col-lg-2">
            <img
              className="img-responsive left-float"
              src="img/email.png"
              width="128"
              height="128"
              alt="contact london kickboxing"
            />
          </div>
          <div className="col-lg-10">
            <div className="form">
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  required
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                />

                {/* <input
                  type="telephone"
                  name="telephone"
                  value={formData.telephone}
                  onChange={handleChange}
                  placeholder="Telephone"
                  // required
                /> */}

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message"
                  required
                />

                <button type="submit">Send</button>

                {status && <p>{status}</p>}
              </form>
            </div>
          </div>
        </div>
        <br />
      </div>
      {/* Modal */}
      {/* <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            <strong>Due to technical reasons, the mail was not sent.</strong>
          </p>
          <p>
            Please copy the following information and send it directly to info@londonkickboxing.co.uk from your
            email.
          </p>

          <br />
          <h3>Contact information</h3>
          <p>
            <strong>Name:</strong> {formData.name}
            <br />
            <strong>Email:</strong> {formData.email}
            <br />
            <strong>Telephone:</strong> {formData.telephone}
            <br />
            <strong>Message:</strong> {formData.message}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default Contacts_In;
